import React, {ReactElement} from "react"
import {
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {DeleteOutline} from "@mui/icons-material";
import {Tooltip} from "../../../../App/components/Tooltip";
import {useAppDispatch} from "../../../../App/hooks/store";
import {GroupActions} from "../../actions/group";
import {IGroup} from "../../../../Account/interfaces/group";

interface Props {
  group: IGroup
  onClose: (id: number) => void
}

export function Delete(props: Props): ReactElement | null {
  const dispatch = useAppDispatch();
  const { group, onClose } = props

  return (
    <Grid item>
      <Tooltip title="Удалить" placement="right">
        <IconButton
          edge="start"
          color="primary"
          onClick={(e) => {
            e.stopPropagation()
            dispatch(GroupActions.delete(group.id)).then(() => {
              onClose(group.id)
            })
          }}
        >
          <DeleteOutline />
        </IconButton>
      </Tooltip>
    </Grid>
  )
}
